import { ContentObject, SetupConfig } from '../interfaces/copilotChat';

export const hasArtifactName = (setupConfig: SetupConfig) => {
  return setupConfig.artifactFQN || setupConfig.artifactName;
};

export const getArtifactName = (setupConfig: SetupConfig) => {
  return setupConfig.artifactName ?? setupConfig.artifactFQN;
};

export const getArtifactContent = (result: ContentObject) => {
  return (
    (result.text ?? '') +
    '\n\n' +
    (result.code
      ?.map((code) => `\`\`\`apex\n${code.contents}\n\`\`\``)
      .join('\n\n') || '')
  );
};

export const getRecordTable = (result: ContentObject) => {
  return `| Type | ID |\n| --- | --- |\n| ${result.type} | ${result.id} |`;
};
